import { Box, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { queryClient } from "../..";
import { OverlayLoader } from "../../ui/atoms/OverlayLoader";
import { EmptyData } from "../../ui/atoms/EmptyData";
import { BillingAPI } from "../../utils/api/requests/billing-requests";
import { ExpenseItem } from "./ui/molecules/ExpenseItem";

export const ExpensesList: FC = () => {
  const { t } = useTranslation();

  const { data, isFetching } = useQuery({
    queryFn: () => BillingAPI.getExpensesList(),
    queryKey: "expensesList",
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    return () => {
      queryClient.resetQueries("expensesList");
    };
  }, []);

  const gridTemplateColumns = "1.4fr 0.5fr";

  return (
    <Box
      sx={{ width: "100%", minWidth: { xs: "none", sm: "none", md: "1024px" } }}
    >
      <Typography sx={{ mb: "16px" }} variant="h4">
        {t("expenses.expenses")}
      </Typography>
      {(!data || isFetching) && <OverlayLoader />}
      <Box
        sx={{
          width: "100%",
          boxShadow:
            "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px",
          borderRadius: "16px",
        }}
      >
        {data?.length ? (
          <Box
            sx={{
              backgroundColor: "rgb(248, 249, 250)",
              height: "40px",
              display: { xs: "none", sm: "none", md: "grid" },
              gridTemplateColumns: gridTemplateColumns,
              px: "24px",
              py: "8px",
              color: "rgb(47, 55, 70)",
              textTransform: "uppercase",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", maxWidth: "250px" }}
            >
              <Typography sx={{ fontSize: "0.875rem" }}>
                {t("expenses.day")}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {t("expenses.amount")}
              </Typography>
            </Box>
          </Box>
        ) : null}
        {data?.map((expense) => (
          <ExpenseItem
            expense={expense}
            key={expense.day}
            gridTemplateColumns={gridTemplateColumns}
          />
        ))}
      </Box>
      {!data?.length && !isFetching && (
        <EmptyData text={t("expenses.emptyData")} />
      )}
    </Box>
  );
};
